import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Seo from '../Seo';

/**
 * Shared chrome for every individual service page: SEO/JSON-LD, breadcrumb nav,
 * the page H1/subhead, the bespoke body (children), back-links to the services
 * index and homepage, and the site footer. Pages supply only their own content.
 */
const ServicePageLayout = ({ service, h1, subhead, children }) => {
  // Land at the top of the page when arriving from a card link.
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Seo {...service.seo} />
      <main className="service-page page-content">
        <nav className="breadcrumb" aria-label="Breadcrumb">
          <Link to="/">Home</Link>
          <span className="breadcrumb-sep" aria-hidden="true">/</span>
          <Link to="/services">Services</Link>
          <span className="breadcrumb-sep" aria-hidden="true">/</span>
          <span aria-current="page">{service.breadcrumb}</span>
        </nav>

        <header className="service-hero">
          <h1>{h1}</h1>
          {subhead && <p className="service-subhead">{subhead}</p>}
        </header>

        {children}

        <div className="service-backlinks">
          <Link to="/services" className="secondary-btn">← All Services</Link>
          <Link to="/" className="secondary-btn">Tavernix Home</Link>
        </div>
      </main>

      <footer>
        <p>&copy; 2026 TAVERNIX SYSTEMS // EST_2024</p>
      </footer>
    </>
  );
};

/** Reusable section: an <h2> heading plus a grid of <h3> feature cards. */
export const FeatureGrid = ({ heading, intro, features }) => (
  <section className="service-section">
    <h2>{heading}</h2>
    {intro && <p className="service-intro">{intro}</p>}
    <div className="service-feature-grid">
      {features.map((feature) => (
        <div className="custom-card" key={feature.title}>
          <h3>{feature.title}</h3>
          <p>{feature.desc}</p>
        </div>
      ))}
    </div>
  </section>
);

/** Reusable end-of-page call to action. */
export const ServiceCTA = ({ heading, blurb, label, href }) => (
  <section className="service-cta">
    {heading && <h2>{heading}</h2>}
    {blurb && <p>{blurb}</p>}
    <a className="primary-btn" href={href}>{label}</a>
  </section>
);

export default ServicePageLayout;
